import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class Certification extends Mappeable {

    idTypeCertificationPk: number;
    txtTypeCertification: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtTypeCertification: this.txtTypeCertification,
            mrkActive: this.mrkActive ? 1 : 0
        }
    }


}
